import { styled } from "styled-components";

export const QrCodeComponentStyle = styled.div`
display: none;
    bottom: 40vh;
    left: 3vw;
    position: fixed;
    z-index: 1000;
`